import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';

import { HeaderHostDirective } from './header-host.directive';

import { ButtonModule } from '@shared/components/button/button.module';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule
  ],
  declarations: [
    HeaderComponent,
    HeaderHostDirective
  ],
  exports: [HeaderComponent]
})
export class HeaderModule { }
